<template>
  <div>
    <event-header :event="event" />

    <event-stats></event-stats>

    <!-- Vanity url -->
    <div class="w-full md:w-2/3 mt-10">
      <div class="shadow rounded p-5">
        <div class="text-xl">Veranstaltungs-URL</div>

        <p class="mt-4 text-sm">
          Die Veranstaltungs-URL ist die offizielle URL zu deiner Veranstaltung. Die URL bleibt auch
          gültig, wenn du den Namen der Veranstaltung später noch änderst.
        </p>

        <p class="mt-4 text-sm">
          Wenn eine einfach einzuprägende URL benötigt wird, kann eine Vanity-URL angelegt werden.
          Diese leitet zur Veranstaltungs-URL weiter.
        </p>

        <div class="mt-4 w-full md:w-4/5">
          <div>
            <div class="mt-1 flex rounded-md shadow-sm">
              <div class="relative flex-grow focus-within:z-10">
                <input
                  disabled
                  class="form-input block w-full rounded-none rounded-l-md transition ease-in-out duration-150 sm:text-sm sm:leading-5 disabled:opacity-75"
                  :value="generateEventUrl(event)"
                />
              </div>
              <button
                class="-ml-px relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm leading-5 font-medium rounded-r-md text-gray-700 bg-gray-50 hover:text-gray-500 hover:bg-white focus:outline-none focus:shadow-outline-blue focus:border-blue-300 active:bg-gray-100 active:text-gray-700 transition ease-in-out duration-150"
                v-clipboard:copy="generateEventUrl(event)"
                v-clipboard:success="onCopy"
              >
                <font-awesome-icon icon="copy" />
                <span class="ml-2">Kopieren</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Listing -->

    <listing :event="event" />

    <!-- Copy event -->
    <div class="w-2/3 mt-10">
      <div class="shadow rounded-t p-5">
        <div class="text-xl">Veranstaltung kopieren</div>

        <p class="mt-4 text-sm">
          Diese Aktion kopiert die Veranstaltung. Die kopierte Veranstaltung befindet sich danach im
          Entwurf.
        </p>

        <p class="mt-2 text-sm">
          Personalisierungseinstellungen werden momentan noch nicht mit kopiert.
        </p>
      </div>
      <div class="py-3 px-4 -mt-px flex justify-end shadow border-t rounded-b bg-gray-50">
        <basic-button
          v-if="!['28524', '28675', '28523'].includes(this.$route.params.organizer)"
          :loading="duplicateLoading"
          @click="duplicate()"
          size="sm"
          color="white"
          >Kopieren</basic-button
        >
        <div v-else>Nur im Central Next verfügbar</div>
      </div>
    </div>

    <!-- Export -->

    <div class="w-full md:w-2/3 mt-10">
      <div class="shadow rounded p-5">
        <div class="text-xl">Datenexport</div>

        <p class="mt-4 text-sm">
          Export von Bestellungen: Es erfolgt ein Export aller Bestellungen mit dem Status:
          "Erfolgreich", "Erstattet", "Teilweise Erstattet".
        </p>

        <p class="mt-4 text-sm">
          Export von Tickets: Es erfolgt ein Export aller Tickets mit dem Status: "Erfolgreich",
          "Erstattet", "Teilweise Erstattet".
        </p>

        <div class="mt-4 w-full">
          <div class="flex gap-3 justify-end">
            <a
              :href="event.export.orders"
              target="_blank"
              class="inline-flex items-center border font-medium text-white focus:outline-none transition ease-in-out duration-150 bg-green-500 hover:bg-green-400 focus:border-green-700 active:bg-green-700 focus:shadow-outline-green disabled:bg-green-300 border-transparent px-3 py-2 text-sm leading-4 rounded-md"
              >Bestellungen Exportieren</a
            >
            <a
              :href="event.export.exportGroupedByChannel"
              target="_blank"
              class="inline-flex items-center border font-medium text-white focus:outline-none transition ease-in-out duration-150 bg-green-500 hover:bg-green-400 focus:border-green-700 active:bg-green-700 focus:shadow-outline-green disabled:bg-green-300 border-transparent px-3 py-2 text-sm leading-4 rounded-md"
              >Bestellungen (groupiert) Exportieren</a
            >
            <a
              :href="event.export.tickets"
              target="_blank"
              class="inline-flex items-center border font-medium text-white focus:outline-none transition ease-in-out duration-150 bg-green-500 hover:bg-green-400 focus:border-green-700 active:bg-green-700 focus:shadow-outline-green disabled:bg-green-300 border-transparent px-3 py-2 text-sm leading-4 rounded-md"
              >Tickets Exportieren</a
            >
          </div>
        </div>
      </div>
    </div>

    <!-- Copy -->
    <!-- <div class="w-full md:w-2/3 mt-10 relative">
      <div class="shadow rounded-t p-5">
        <div class="flex items-center">
          <div class="text-xl">Vanity-URL</div>
          <div class="ml-4 text-xs border rounded-full px-2 uppercase">Bald Verfügbar</div>
        </div>

        <p class="mt-4 text-sm">
          Um eine eigene URL anzulegen gebe diese einfach unten ein. Beachte, dass diese eindeutig
          über alle Veranstaltungen in localTicketing sein muss. Es kann also sein, dass deine URL
          schon vergeben ist.
        </p>

        <p class="mt-4 text-sm">Benutze diese nicht für Verlinkungen auf Webseiten.</p>

        <div class="mt-4 w-full md:w-2/3">
          <div class="mt-1 flex rounded-md shadow-sm">
            <span
              class="inline-flex items-center px-3 rounded-l-md border border-r-0 border-gray-300 bg-gray-50 text-gray-500 sm:text-sm"
              >www.lctk.de/</span
            >
            <input
              id="company_website"
              class="form-input flex-1 block w-full px-3 py-2 rounded-none rounded-r-md sm:text-sm sm:leading-5"
            />
          </div>
        </div>
        <div
          class="absolute bg-gray-200 opacity-50 w-full h-full top-0 left-0 rounded cursor-not-allowed"
        ></div>
      </div>
      <div
        class="py-3 px-4 -mt-px flex justify-between items-center shadow border-t rounded-b bg-gray-50"
      >
        <div class="text-gray-800 text-sm">Die maximale Länge beträgt 32 Zeichen.</div>
        <basic-button size="sm">Speichern</basic-button>
      </div>
    </div> -->

    <!-- Reverse event -->
    <!--
    <div class="w-2/3 mt-10" v-if="isPublished">
      <div class="shadow rounded-t p-5">
        <div class="text-xl">Veröffentlichung wiederrufen</div>

        <p
          class="mt-4 text-sm"
        >Um eine Veröffentlichung rückgängig zu machen müssen erst alle Tickets erstattet werden.</p>

        <p class="mt-4 text-sm">
          Diese Veranstaltung hat
          <span class="font-semibold">{{event.tickets_sold}}</span> verkaufte Tickets. Erstatte diese um die Veröffentlichung rückgängig zu machen.
        </p>
      </div>
      <div class="py-3 px-4 -mt-px flex shadow border-t rounded-b bg-gray-50">
        <div
          class="text-gray-800 text-sm py-2"
        >Diese Aktion kann momentan nur vom Support ausgeführt werden.</div>
        <basic-button size="sm" color="white" class="hidden">Veröffentlichung wiederrufen</basic-button>
      </div>
    </div>
    -->

    <!-- Delete event
    <div class="w-2/3 mt-10" v-if="isDraft">
      <div class="shadow rounded-t p-5">
        <div class="text-xl">Veranstaltung löschen</div>

        <p class="mt-4 text-sm">Diese Aktion löscht die Veranstaltung unwiederruflich.</p>

        <p class="mt-2 text-sm">
          Eine Veranstaltung kann nach der Veröffentlichung nicht mehr gelöscht werden. Wenn noch
          keine Tickets verkauft wurden kann die Veröffentlichung jedoch rückgängig gemacht werden.
        </p>
      </div>
      <div class="py-3 px-4 -mt-px flex justify-end shadow border-t rounded-b bg-gray-50">
        <basic-button size="sm" color="white">Löschen</basic-button>
      </div>
    </div> -->
  </div>
</template>

<script>
import EventStats from '@/components/statistics/EventStats';
import EventHeader from '@/components/EventHeader';

import Listing from '@/components/events/Listing';
import eventsClient from '@/api/central/events';

import InteractsWithEventUrl from '@/mixins/InteractsWithEventUrl';
import InteractsWithEventStatus from '@/mixins/InteractsWithEventStatus';

export default {
  props: ['event'],

  components: {
    EventStats,
    EventHeader,
    Listing,
  },

  mixins: [InteractsWithEventUrl, InteractsWithEventStatus],

  data() {
    return {
      duplicateLoading: false,
    };
  },

  methods: {
    onCopy: function (e) {
      this.$toasted.success('Erfolgreich kopiert.');
    },

    duplicate() {
      this.duplicateLoading = true;

      eventsClient
        .duplicate(this.event.id)
        .then(async (data) => {
          console.log(data);

          this.$router.push({
            name: 'events.details',
            params: {
              id: data.data.data.id,
            },
          });

          this.$toasted.success('Veranstaltung erfolgreich kopiert.');
        })
        .catch((error) => {
          this.$toasted.global.error();
        })
        .then(() => {
          this.duplicateLoading = false;
        });
    },
  },
};
</script>
